export default import.meta.ROLLUP_FILE_URL_tfmsSEegTz6HwdunniGCkA